<template>
  <div class="cities">
    <SidebarLayout3 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>Ações da página</Heading>
          <!-- CADASTRAR -->
          <Button
            :disabled="checkDisableSave()"
            tooltipText="Necessário selecionar a cidade e preencher o seu nome"
            class="page-actions--button"
            @click="cityId == null ? saveCity() : editCity()"
          >
            Salvar
          </Button>
          <!-- LISTAGEM DE CIDADES -->
          <Button
            link="/cidades"
            element="router-link"
            class="page-actions--button"
            layout="outline"
          >
            Voltar sem salvar
          </Button>
          <!-- EXCLUIR -->
          <Button
            :disabled="cityId === null"
            variation="error"
            class="page-actions--button"
            @click="showAlertModal = true"
          >
            Excluir
          </Button>
        </SidebarBlock>
        <!-- DICAS -->
        <SidebarBlock class="tips">
          <Heading>
            Dica
          </Heading>
          <Paragraph>
            Não encontrou a cidade desejada na lista? Para adicionar novas
            cidades, entre em contato com nosso suporte clicando aqui.
          </Paragraph>
        </SidebarBlock>
      </template>
      <!-- CONTEÚDO -->
      <template #content class="form">
        <!-- SELECIONE A CIDADE -->
        <FormSelect
          v-model="form.city"
          :options="form.cities"
          :search="true"
          label="Selecione a cidade"
          placeholder=""
          class="form--input"
          @change="changeCity()"
        />
        <div class="form--line">
          <!-- NOME -->
          <FormInput
            v-model="form.name"
            label="Nome"
            placeholder=""
            class="form--input"
          />
          <!-- SIGLA -->
          <FormInput
            v-model="form.acronym"
            :infoIcon="true"
            :disabled="true"
            infoText="Sigla da cidade, não pode ser repetida no sistema."
            label="Sigla"
            placeholder="Exemplo: POA"
            class="form--input form--input__label-abled"
          />
        </div>
        <div class="form--line">
          <!-- ESTADO -->
          <FormInput
            v-model="form.state"
            :disabled="true"
            label="Estado"
            placeholder="Exemplo: Rio Grande do Sul"
            class="form--input"
          />
          <!-- PAÍS -->
          <FormInput
            v-model="form.country"
            :disabled="true"
            label="País"
            placeholder="Exemplo: Brasil"
            class="form--input"
          />
        </div>

        <!-- AÇÕES -->
        <div class="form--actions">
          <!-- CANCELAR -->
          <Button
            :link="`/cidades`"
            element="router-link"
            layout="outline"
            size="large"
          >
            Voltar sem salvar
          </Button>
          <!-- SALVAR -->
          <Button
            :disabled="checkDisableSave()"
            tooltipText="Necessário selecionar a cidade e preencher o seu nome"
            popperPosition="top"
            tooltipMinWidth="230"
            popperStrategy="absolute"
            size="large"
            @click="cityId == null ? saveCity() : editCity()"
          >
            Salvar
          </Button>
        </div>
      </template>
    </SidebarLayout3>
    <!-- MODAL DE EXCLUSÃO DE CIDADE -->
    <AlertModal
      v-model="showAlertModal"
      title="Excluir cidade"
      icon="trash-can"
      cancelButtonText="Cancelar"
      @alert-modal-confirm="inativeCities"
      @alert-modal-cancel="cancelInativeCities"
    >
      <template #text>
        Ao excluir essa cidade, ela não poderá<br />
        ser mais vinculada aos hotéis. <br />
        Tem certeza de que quer fazer isso?
      </template>
    </AlertModal>
    <!-- MODAL DE ALERTA DE EXCLUSÃO DE CIDADE -->
    <AlertModal
      v-model="showAlertModalCityCantDelete"
      title="Atenção"
      confirmButtonText="Ok, entendi"
      cancelButtonText="Cancelar"
      @alert-modal-confirm="showAlertModalCityCantDelete = false"
      @alert-modal-cancel="showAlertModalCityCantDelete = false"
    >
      <template #text>
        Não foi possível excluir, pois existem hotéis <br />
        vinculados a essa cidade. Para realizar a exclusão, <br />
        é necessário desvincular a cidade. É possível <br />
        buscar e encontrar quais hotéis estão vinculados a ela
        <button class="link" @click="toHotels()">clicando aqui</button>.
      </template>
    </AlertModal>
  </div>
</template>

<script>
import SidebarLayout3 from '@/layouts/SidebarLayout3'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import FormSelect from '@solucoes/components-lib-tmp/src/components/elements/FormSelect'
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'

export default {
  name: 'CitiesCreate',
  components: {
    SidebarLayout3,
    SidebarBlock,
    Heading,
    Button,
    FormSelect,
    FormInput,
    Paragraph,
    AlertModal
  },
  data() {
    return {
      breadcrumb: [
        {
          label: 'Site Letsbook',
          isSpa: false /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'Cidades',
          url: '/cidades',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'Cadastrar nova cidade',
          url: '/cidades/criar',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        }
      ],
      cityId: null,
      pageTitle: 'Cadastrar nova cidade',
      /** Dados para o formmulário */
      form: {
        cities: [],
        city: null,
        name: null,
        acronym: null,
        state: null,
        country: null
      },
      /** Mostrar modais */
      showAlertModal: false,
      /** Mostar modal de alerta caso a cidade não possa ser excluída */
      showAlertModalCityCantDelete: false
    }
  },
  async created() {
    /** Buscar sa cidades pré-cadastradas */
    await this.getCities()
    /** Se for edição, pegar o ID e a cidade */
    this.cityId = this.$route.params.id || null
    if (this.cityId !== null) {
      this.getCity()
    }
  },
  methods: {
    /** Se for edição, buscar a cidade */
    getCity() {
      this.$cities
        .get(this.cityId)
        .then(async (response) => {
          /** Pegar os dados da cidade */
          this.form.name = response.data.nome
          this.form.city = await this.getCityInList(response.data.sigla)
          /** Atualizar os valores da cidade */
          this.changeCity(response.data.nome)
          /** Atualizar o breadcrump */
          this.pageTitle = `Editando ${response.data.nome}`
          this.breadcrumb[
            this.breadcrumb.length - 1
          ].label = `Editando ${response.data.nome}`
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao buscar a cidade'
          })
          /** Redirecionar para a listagem de cidades */
          setTimeout(() => {
            this.$router.push({
              path: '/cidades'
            })
          }, 1000)
        })
    },

    /** Buscar cidades pré-cadastradas */
    getCities() {
      return this.$cities
        .getDefaultCities()
        .then((response) => {
          /** Formatar dados para a tabela */
          this.form.cities = response.data.map((item) => {
            const obj = {
              text: `${item.nome}-${item.codigoEstado}, ${item.estado}`,
              value: item.sigla,
              nome: item.nome,
              sigla: item.codigoEstado,
              pais: item.pais,
              estado: item.estado
            }
            return obj
          })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao buscar as cidades padrão'
          })
          /** Redirecionar para a listagem de cidades */
          setTimeout(() => {
            this.$router.push({
              path: '/cidades'
            })
          }, 1000)
        })
    },

    /** Salvar cidades */
    saveCity() {
      const data = {
        nome: this.form.name,
        sigla: this.form.acronym
      }
      this.$cities
        .create(data)
        .then(() => {
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Cidade criada com sucesso!'
          })
          /** Redirecionar para a listagem de cidades */
          setTimeout(() => {
            this.$router.push({
              path: '/cidades'
            })
          }, 1000)
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
        })
    },

    /** Editar grupo de usuários */
    editCity() {
      const data = {
        codigo: parseInt(this.cityId),
        nome: this.form.name,
        sigla: this.form.acronym
      }
      this.$cities
        .edit(data)
        .then(() => {
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Cidade editada com sucesso!'
          })
          /** Redirecionar para a listagem de cidades */
          setTimeout(() => {
            this.$router.push({
              path: '/cidades'
            })
          }, 1000)
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
        })
    },

    /** Inativar cidade */
    inativeCities() {
      this.$cities
        .inative([parseInt(this.cityId)])
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Cidade excluída com sucesso.'
          })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao excluir a cidade.'
          })
        })
        .finally(() => {
          this.showAlertModalCityCantDelete = true
        })
    },

    /** Cancelar inativação das cidades */
    cancelInativeCities() {
      this.showAlertModal = false
    },

    /** Habilitar/desabilitar o botão "Salvar" */
    checkDisableSave() {
      const hasCity = this.form.city !== null
      const hasName = this.form.name !== null && this.form.name.length
      return hasCity && hasName ? false : true
    },

    /** Função ao selecionar uma cidade */
    changeCity(name = null) {
      /** Se for uma edição, trazer o nome cadastrado */
      if (name) this.form.name = name
      else
        this.form.name = this.form.city ? this.form.city.nome : this.form.name
      this.form.acronym = this.form.city ? this.form.city.value : ''
      this.form.state = this.form.city ? this.form.city.estado : ''
      this.form.country = this.form.city ? this.form.city.pais : ''
    },

    /** Pesquisar cidade na listagem de cidades pré-cadastradas */
    getCityInList(acronym = '') {
      const item = this.form.cities.find((item) => item.value === acronym)
      return item
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
.cities {
  .page-actions {
    .heading {
      margin-bottom: 15px;
    }
    &--button {
      width: 100%;

      & + .page-actions--button {
        margin-top: 10px;
      }
    }
  }
  .tips {
    .paragraph {
      line-height: 21px;
    }
  }
  .form {
    &--input {
      max-width: 256px;

      ::v-deep .input--clear {
        display: none;
      }

      &__label-abled {
        opacity: 1;
        filter: unset;
        pointer-events: unset;

        :v-deep {
          .input {
            opacity: 0.5;
            filter: grayscale(1);
            pointer-events: none;
          }
        }
      }
    }
    &--heading {
      color: $pmw-gray-darkest;
      font-weight: 300;
      margin-bottom: 40px;
    }
    &--line {
      display: flex;
      align-items: baseline;
      margin-top: 30px;
      gap: 20px;
    }

    &--register {
      display: flex;
      align-items: center;
      gap: 20px;

      .heading {
        font-size: font-size('size-medium');
        color: $pmw-gray-dark;
        line-height: 21px;
        margin-bottom: 10px;
      }

      .paragraph {
        font-size: font-size('size-small');
        color: $pmw-gray-dark;
        line-height: 18px;
        font-weight: 100;
      }
    }
    &--actions {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 50px;
    }
  }
}
.link {
  border: none;
  background: inherit;
  color: $primary;
  line-height: 21px;
  padding: 0px;
}
</style>
